import { Container, Graphics } from "pixi.js";
import { indoor, windows } from "./common.js";

/** Bloque 11C: aula teórica. Pizarra al frente y ventanas al pasillo. */
export function aulas(): Container {
  const scene = indoor({ wall: 0xe7ecf2, floor: 0xc9cfd4 });

  windows(scene, 3, 60, 0xa8d8ee);

  const board = new Graphics();
  board.rect(600, 70, 300, 130).fill(0x2f4f3f).stroke({ width: 8, color: 0xd8c9a8 });
  // Cuatro trazos de tiza: alcanza para que se lea como una clase empezada.
  for (let i = 0; i < 4; i++) {
    board.rect(626, 96 + i * 24, 120 + (i % 2) * 90, 6).fill({ color: 0xf2f6f4, alpha: 0.55 });
  }
  scene.addChild(board);

  const clock = new Graphics();
  clock.circle(520, 110, 26).fill(0xf4f7fa).stroke({ width: 4, color: 0x51606e });
  clock.moveTo(520, 110).lineTo(520, 94).stroke({ width: 3, color: 0x2b3a47 });
  clock.moveTo(520, 110).lineTo(534, 116).stroke({ width: 3, color: 0x2b3a47 });
  scene.addChild(clock);

  return scene;
}
